"use client";

import Image from "next/image";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from "@repo/ui/components/ui/carousel";
import { useTranslations } from "next-intl";

export default function Features() {
  const t = useTranslations();

  const features = [
    {
      image: "/marketplace/1.png",
      title: "Home.features.slide1.title",
      subtitle: "Home.features.slide1.subtitle",
      description: "Home.features.slide1.description",
    },
    {
      image: "/marketplace/2.png",
      title: "Home.features.slide2.title",
      subtitle: "Home.features.slide2.subtitle",
      description: "Home.features.slide2.description",
    },
    {
      image: "/marketplace/3.png",
      title: "Home.features.slide3.title",
      subtitle: "Home.features.slide3.subtitle",
      description: "Home.features.slide3.description",
    },
  ];

  return (
    <div className="w-full">
      <Carousel
        autoplay={false}
        navigation={true}
        className="relative w-full rounded-none"
      >
        <CarouselContent className="flex">
          {features.map((item, idx: number) => (
            <CarouselItem key={idx} className="w-full">
              <h2 className="mt-[40px] mb-[60px] max-md:mt-[20px] text-center max-md:text-[30px] font-bold leading-none">
                {t.rich(item.title, {
                  strong: (chunks) => (
                    <strong className="font-bold">{chunks}</strong>
                  ),
                })}
              </h2>
              <section className="pl-4 grid grid-cols-1 gap-[60px] lg:grid-cols-2">
                <div className="order-2 lg:order-1 flex flex-col justify-center text-center lg:text-left">
                  <h3 className="text-2xl lg:text-4xl font-bold mb-4">
                    {t(item.subtitle)}
                  </h3>
                  <p className="text-lg">
                    {t.rich(item.description, {
                      br: () => <br />,
                    })}
                  </p>
                </div>
                <div className="order-1 lg:order-2 flex justify-between items-center">
                  <div className="w-[60px] h-[80%] bg-secondary-gray1 rounded-l-[50px] max-md:rounded-l-[30px]" />
                  <div className="relative w-[100%] aspect-square overflow-hidden rounded-[50px] max-md:rounded-[30px]">
                    <Image src={item.image || ""} alt={item.title || ""} fill />
                  </div>
                  <div className="w-[60px] h-[80%] bg-[#373737] rounded-r-[50px] max-md:rounded-r-[30px]" />
                </div>
              </section>
            </CarouselItem>
          ))}
        </CarouselContent>
      </Carousel>
    </div>
  );
}
